import api from './axios';

export async function fetchEmailSummary() {
  const { data } = await api.get('/admin/email/summary');
  return data;
}

export async function searchEmailRecipients(query) {
  const { data } = await api.get('/admin/email/recipients/search', {
    params: { q: query },
  });
  return Array.isArray(data?.recipients) ? data.recipients : [];
}

export async function createEmailCampaign(payload) {
  const { data } = await api.post('/admin/email/campaigns', payload);
  return data;
}

export async function fetchEmailCampaigns(params = {}) {
  const { data } = await api.get('/admin/email/campaigns', { params });
  return data;
}

export async function fetchEmailDeliveries(campaignId, params = {}) {
  const { data } = await api.get(`/admin/email/campaigns/${encodeURIComponent(campaignId)}/deliveries`, { params });
  return data;
}

export async function fetchMailboxStatus() {
  const { data } = await api.get('/admin/email/mailbox/status');
  return data;
}

export async function fetchMailboxMessages(folder = 'inbox', limit = 50, filters = {}) {
  const { data } = await api.get('/admin/email/mailbox/messages', {
    params: {
      folder,
      limit,
      ...(filters?.from ? { from: filters.from } : {}),
      ...(filters?.to ? { to: filters.to } : {}),
    },
  });
  return data;
}

export async function fetchMailboxMessage(messageId) {
  const { data } = await api.get(`/admin/email/mailbox/messages/${encodeURIComponent(messageId)}`);
  return data;
}

export async function markMailboxMessageRead(messageId, isRead = true) {
  const { data } = await api.patch(`/admin/email/mailbox/messages/${encodeURIComponent(messageId)}/read`, {
    is_read: Boolean(isRead),
  });
  return data;
}

export async function sendMailboxMessage(payload) {
  const { data } = await api.post('/admin/email/mailbox/send', payload);
  return data;
}

export async function replyMailboxMessage(messageId, payload) {
  const { data } = await api.post(`/admin/email/mailbox/messages/${encodeURIComponent(messageId)}/reply`, payload);
  return data;
}

export async function deleteMailboxMessage(messageId) {
  const { data } = await api.delete(`/admin/email/mailbox/messages/${encodeURIComponent(messageId)}`);
  return data;
}
